import React, { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";
import { translations, WHATSAPP_NUMBER } from "@/i18n/translations";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteContext = createContext(null);

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("revive_lang") || "en");
  const [langTick, setLangTick] = useState(0);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const t = translations[lang];

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("revive_lang", l);
    document.documentElement.lang = l;
    setLangTick((n) => n + 1);
  }, []);

  const track = useCallback((event_type, meta) => {
    // fire-and-forget conversion event
    axios.post(`${API}/analytics`, { event_type, meta: meta || null }).catch(() => {});
    if (window.gtag) window.gtag("event", event_type, meta || {});
  }, []);

  const openBooking = useCallback((service) => {
    setPrefill(service ? { treatment_interest: service } : null);
    setBookingOpen(true);
    track("book_consultation_click", service ? { service } : null);
  }, [track]);

  const waMessage = "Hello, I'm interested in learning more about REVIVE Regenerative Medical Clinic and would like to schedule a consultation.";

  const openWhatsApp = useCallback((custom) => {
    const msg = custom || waMessage;
    track("whatsapp_click", null);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, "_blank");
  }, [track, waMessage]);

  return (
    <SiteContext.Provider value={{ lang, langTick, changeLang, t, track, openBooking, openWhatsApp,
      bookingOpen, setBookingOpen, prefill, API }}>
      {children}
    </SiteContext.Provider>
  );
};
